<template>
  <CommonVCard id="add_ons">
    <h2 class="registration-form__header">
      {{ $t("player_registration.add_ons") }}
    </h2>
    <ul v-if="isRenderAddOnsList">
      <AddOnItem
        v-for="item in playerRegistrationAddOns"
        :key="item.id"
        :item="item"
        :registrationTrack="registrationTrack"
      />
    </ul>
    <div v-else class="d-flex justify-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
  </CommonVCard>
</template>

<script>
import CommonVCard from "./CommonVCard";
import AddOnItem from "./AddOnItem";
import { ModuleTypes } from "../../../store/ModuleTypes";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { uuid as vueUuid } from "vue-uuid";

export default {
  name: "PlayerRegistrationFormAddOnsCard",
  components: { CommonVCard, AddOnItem },
  props: {
    registrationTrack: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    ...mapGetters(ModuleTypes.PLAYER_REGISTRATION, [
      "playerRegistrationAddOns",
      "playerRegistrationSummary"
    ]),

    isRenderAddOnsList() {
      return this.playerRegistrationAddOns?.length;
    }
  },
  methods: {
    ...mapActions(ModuleTypes.PLAYER_REGISTRATION, [
      "fetchPlayerRegistrationInfo"
    ]),
    ...mapMutations(ModuleTypes.PLAYER_REGISTRATION, [
      "setPlayerRegistrationAddOns"
    ]),
    handleChangeFanOrFollower(item, updatedItem = null) {
      const index = this.fansOrFollowers.findIndex(el => el.id === item.id);
      if (index !== -1) {
        this.fansOrFollowers.splice(
          index,
          1,
          ...(updatedItem !== null ? [updatedItem] : [])
        );
      }
    }
  },
  watch: {
    playerRegistrationSummary: function(newVal, oldVal) {
      if (this.registrationTrack && newVal) {
        const playerRegistrationAddOns = this.playerRegistrationSummary.addOnsInfoSummaryList.map(
          i => {
            return {
              ...i,
              id: vueUuid.v4(),
              priceIntCents: i.basicPriceInCents,
              isEditMode: true,
              required: true,
              quantity: i.amount,
              addOnOptionList: i.optionInfoList
            };
          }
        );
        this.setPlayerRegistrationAddOns({ playerRegistrationAddOns });
      }
    }
  }
};
</script>

<style scoped>
.registration-form__header {
  font-size: 18px;
  font-weight: 500;
  color: var(--dark-color);
}
</style>
